var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGzIntrusionIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 13a4 4 0 00-4-4H13a4 4 0 00-4 4v48a4 4 0 004 4h51a4 4 0 004-4V13zm-4 48H13V13h51v48zm-5-11H36v-3h23v3zm0-32H36v24h23V18zm-12.79 4.78a3.56 3.56 0 114.446 5.56 3.56 3.56 0 01-4.446-5.56zM54.84 38H42v-2.18A3.63 3.63 0 0145.33 32h6a3.79 3.79 0 013.53 3.82L54.84 38zM49 56H36v-3h13v3zm-19 0H18V18h12v38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/GZ_Intrusion_identification.9de022c3.svg";
export { SvgGzIntrusionIdentification as ReactComponent };